export default __webpack_public_path__ + "static/media/113-jungle.ef8aea9d.jpeg";